var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overflow-y-scroll" }, [
    _c(
      "div",
      { staticClass: "container mt-3" },
      [
        _c("loading", {
          attrs: { active: _vm.loading, "can-cancel": false },
          on: {
            "update:active": function ($event) {
              _vm.loading = $event
            },
          },
        }),
        !_vm.data.selected.unit
          ? _c(
              "div",
              {
                staticClass: "alert alert-danger text-center",
                attrs: { role: "alert" },
              },
              [
                _c("h2", { staticClass: "text-danger" }, [
                  _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
                ]),
              ]
            )
          : _vm._e(),
        !_vm.data.navBarRefresh && _vm.data.selected.unit
          ? _c("div", [
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("remainingLifeOverview")))]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "mt-3", attrs: { id: "accordion" } },
                _vm._l(_vm.result.areas, function (item, index) {
                  return _c(
                    "pui-collapsible",
                    {
                      key: index,
                      staticClass: "card mb-3",
                      attrs: { open: index === 0 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header-item",
                          attrs: {
                            slot: "collapsibleHeader",
                            id: "headingOne-" + index,
                          },
                          slot: "collapsibleHeader",
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.remainingLife !== "",
                                  expression: "item.remainingLife !== ''",
                                },
                              ],
                              staticClass: "progress",
                            },
                            [
                              _c("div", {
                                class: _vm.getProgressBarClass(
                                  item.remainingLife
                                ),
                                style: { width: item.remainingLife + "%" },
                                attrs: {
                                  role: "progressbar",
                                  "aria-valuenow": item.remainingLife,
                                  "aria-valuemin": "0",
                                  "aria-valuemax": "100",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "percent",
                                  class: _vm.getProgressBarColor(
                                    item.remainingLife
                                  ),
                                  style: {
                                    "margin-left": item.remainingLife - 8 + "%",
                                  },
                                },
                                [
                                  _c("p", { staticClass: "percent-number" }, [
                                    _vm._v(
                                      " " + _vm._s(item.remainingLife) + "% "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "arrowdown" }),
                                ]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "pl-4 item-name" }, [
                            _c("h5", [_vm._v(_vm._s(item.name))]),
                          ]),
                        ]
                      ),
                      _c("div", [
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              item.image !== undefined
                                ? _c("div", { staticClass: "col-3" }, [
                                    _c("img", {
                                      staticClass: "img-thumbnail",
                                      attrs: { src: item.image },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._l(item.items, function (subitem) {
                                return _c(
                                  "div",
                                  { staticClass: "col-3 mt-3 mb-2 mr-3" },
                                  [
                                    _c("div", { staticClass: "progress" }, [
                                      _c("div", {
                                        class: _vm.getProgressBarClass(
                                          subitem.remainingLife
                                        ),
                                        style: {
                                          width: subitem.remainingLife + "%",
                                        },
                                        attrs: {
                                          role: "progressbar",
                                          "aria-valuenow":
                                            subitem.remainingLife,
                                          "aria-valuemin": "0",
                                          "aria-valuemax": "100",
                                        },
                                      }),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "percent",
                                        class: _vm.getProgressBarColor(
                                          subitem.remainingLife
                                        ),
                                        style: {
                                          "margin-left":
                                            subitem.remainingLife - 6 + "%",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(subitem.remainingLife) +
                                            "% "
                                        ),
                                        _c("div", { staticClass: "arrowdown" }),
                                      ]
                                    ),
                                    _c("h4", [
                                      _vm._v(_vm._s(subitem.plantItem)),
                                    ]),
                                    _vm._l(
                                      subitem.maintenanceItems,
                                      function (line) {
                                        return _c(
                                          "ul",
                                          [
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "maintenanceActivity"
                                                        )
                                                      ) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(line.maintenance) +
                                                  " "
                                              ),
                                            ]),
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.$t("driver")) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " + _vm._s(line.driver) + " "
                                              ),
                                            ]),
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.$t("model")) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " + _vm._s(line.model) + " "
                                              ),
                                            ]),
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("interval")
                                                      ) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(line.interval) +
                                                  " "
                                              ),
                                            ]),
                                            line.driver2 != null
                                              ? [
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "details",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("driver")
                                                            ) +
                                                            ": "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(line.driver2) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "details",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("model")
                                                            ) +
                                                            ": "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(line.model2) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "details",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("interval")
                                                            ) +
                                                            ": "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(line.interval2) +
                                                        " "
                                                    ),
                                                  ]),
                                                ]
                                              : _vm._e(),
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("duration")
                                                      ) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(line.duration) +
                                                  " "
                                              ),
                                            ]),
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.$t("cost")) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " + _vm._s(line.cost) + " "
                                              ),
                                            ]),
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("currency")
                                                      ) +
                                                      ": "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(line.currency) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }